





import { defineComponent, computed } from '@vue/composition-api';
import { useTranslations } from '@vue-storefront/novulo';

export default defineComponent({
  props: {
    product: {
      type: Object,
      required: true,
      default: null
    }
  },
  setup(props) {
    const { translate } = useTranslations();

    const addToCartText = computed(() => {
      const stockClassificationCode = props.product?.stock_classification_code;
      const addToCartKey = stockClassificationCode
        ? `add_to_cart_button_${stockClassificationCode}`
        : 'add_to_cart_button';
      return translate(addToCartKey);
    });

    return {
      addToCartText
    };
  }
});
